export default "__VITE_ASSET__BGTCS5jB__"